import React from 'react';
import { input } from '../utilities/inputObjects';
import styles from '../styles/componentStyle/entrance/fieldFormCcusCheckbox.scss';
import { messageUtility } from '../utilities/messageUtility';
import Tippy, { ToolTip } from './ReactTippy';

export const FieldFormCcusCheckbox = ({
  checked,
  disabled,
  onChange,
  ccusSecededFlag,
}) => (
  <Tippy
    duration={10}
    distance={24}
    arrow={true}
    delay={[500, 0]}
    placement='top'
    disable={!ccusSecededFlag}
    html={
      <ToolTip tooltipStyle={{ whiteSpace: 'pre' }}>
        {messageUtility.getMessage('I-000-242')}
      </ToolTip>
    }
  >
    <div className={`${styles['fieldFormCcusCheckbox']} form-list-default`}>
      <label
        className={`checkbox fieldCcusCheckbox-label ${
          disabled ? 'fieldCcusCheckbox--disabled' : ''
        }`}
      >
        <input
          id='field_ccus_checkbox'
          type='checkbox'
          className='fieldCcusCheckbox-checkbox'
          disabled={disabled}
          checked={checked}
          onChange={() => {
            !disabled && onChange();
          }}
        />
        <i className='i-square i-3x' />
        入力した内容をCCUSにも登録する
      </label>
    </div>
  </Tippy>
);



// WEBPACK FOOTER //
// ./src/components/FieldFormCcusCheckbox.jsx